require('./bootstrap')
require('@/config/axios')

import router from '@/router'
import store from '@/store'
import app from '@/app.vue'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Progress from 'vue-progressbar'
import progressConfig from '@/config/progress'
import Vuelidate from 'vuelidate'
import axios from 'axios'
import i18n from '@/config/i18n'
import VueAxios from 'vue-axios'
import Toasted from 'vue-toasted'
import toastedConfig from '@/config/toasted'
import ImageUploader from 'vue-image-upload-resize'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, 
  faUsers, 
  faBuilding, 
  faFolderOpen, 
  faEuroSign, 
  faProjectDiagram, 
  faBalanceScale,
  faBarcode,
  faHome,
  faArchive,
  faList
 } from '@fortawesome/free-solid-svg-icons'
import spinner from '@/components/common/spinner'


import auth from '@websanova/vue-auth/dist/v2/vue-auth.esm.js'
import driverAuthBearer from '@websanova/vue-auth/dist/drivers/auth/bearer.esm.js'
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js'
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js'

library.add(
  faUser, 
  faUsers, 
  faBuilding, 
  faFolderOpen, 
  faEuroSign, 
  faProjectDiagram, 
  faBalanceScale ,
  faBarcode,
  faHome,
  faArchive,
  faList
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Progress, progressConfig)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)
Vue.use(Toasted, toastedConfig)
Vue.use(ImageUploader)
Vue.component('spinner', spinner)

Vue.router = router
Vue.prototype.$axios = axios

Vue.use(auth, {
  plugins: {
    http: Vue.axios,
    router: Vue.router,
  },
  drivers: {
    auth: driverAuthBearer,
    http: driverHttpAxios,
    router: driverRouterVueRouter,
  },
  options: {
    rolesKey: 'type',
    loginData: {
      url: '../api/auth/login',
      method: 'POST',
      redirect: { name: 'dashboard' },
      fetchUser: true,
      staySignedIn: true
    },
    registerData: {
      url: '../api/auth/register',
      method: 'POST',
      redirect: { name: 'login' }
    },
    logoutData: {
      url: '../api/auth/logout',
      method: 'POST',
      redirect: { name: 'login' },
      makeRequest: false
    },
    fetchData: { url: '../api/auth/user', method: 'GET', enabled: true },
    refreshData: {
      url: '../api/auth/refresh',
      method: 'GET',
      enabled: true,
      interval: 30
    },
    authRedirect: { path: '/login' },
    notFoundRedirect: { path: '/404' },
    forbiddenRedirect: { path: '/login' },
  }
})

export default new Vue({
  i18n,
  router,
  store,
  render: h => h(app)
}).$mount('#app')